import { Component, Output, EventEmitter, Input, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-create-template-dialog',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="modal-overlay" (click)="onCancel()">
      <div class="modal-container" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <div class="modal-icon"><mat-icon aria-hidden="true">fiber_new</mat-icon></div>
          <h3 class="modal-title">Créer un nouveau template</h3>
        </div>
        <div class="modal-body">
          <p>Comment souhaitez-vous créer la nouvelle version du template ?</p>
          <div class="choice-cards">
            <div class="choice-card" (click)="onChoice('scratch')">
              <div class="choice-icon"><mat-icon aria-hidden="true">description</mat-icon></div>
              <div class="choice-text">
                <strong>À partir de zéro</strong>
                <span>Commencer avec un template vide</span>
              </div>
            </div>
            <div class="choice-card" (click)="canDuplicate ? onChoice('duplicate') : null" [class.disabled]="!canDuplicate">
              <div class="choice-icon"><mat-icon aria-hidden="true">content_copy</mat-icon></div>
              <div class="choice-text">
                <strong>Dupliquer l'actuel</strong>
                <span>{{ canDuplicate ? 'Copier la structure de la dernière version' : 'Aucune version à dupliquer' }}</span>
              </div>
            </div>
            <div
              class="choice-card upload-card"
              [class.disabled]="uploading"
              [class.drag-over]="isDragOver"
              (click)="openFilePicker()"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)"
              (drop)="onDrop($event)">
              <input #fileInput type="file" accept=".xlsx" (change)="onFileSelected($event)" hidden>
              <div class="choice-icon"><mat-icon aria-hidden="true">cloud_upload</mat-icon></div>
              <div class="choice-text">
                <strong>Importer depuis Excel</strong>
                <span>Glisser-déposer un fichier .xlsx</span>
              </div>
              <div class="upload-cta">{{ uploading ? 'Import en cours...' : 'Déposer le fichier ici ou cliquer' }}</div>
              <div class="upload-file" *ngIf="selectedFileName">{{ selectedFileName }}</div>
              <div class="upload-error" *ngIf="errorMessage">{{ errorMessage }}</div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="onCancel()">Annuler</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
      backdrop-filter: blur(2px);
    }
    .modal-container {
      background: white;
      border-radius: 12px;
      width: 100%;
      max-width: 500px;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
      overflow: hidden;
      animation: modalFadeIn 0.2s ease-out;
    }
    @keyframes modalFadeIn {
      from { opacity: 0; transform: scale(0.95); }
      to { opacity: 1; transform: scale(1); }
    }
    .modal-header {
      padding: 1.5rem 1.5rem 0.5rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
    .modal-icon {
      font-size: 3rem;
      width: 3rem;
      height: 3rem;
      margin-bottom: 1rem;
    }
    .primary-icon {
      color: #1a237e;
    }
    .modal-title {
      margin: 0;
      font-size: 1.25rem;
      font-weight: 700;
      color: #1a237e;
    }
    .modal-body {
      padding: 1.5rem;
      text-align: center;
      color: #666;
    }
    .choice-cards {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-top: 1.5rem;
    }
    .choice-card {
      display: flex;
      align-items: center;
      padding: 1rem;
      border: 1px solid #e2e6ea;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s;
      text-align: left;
    }
    .choice-card:hover:not(.disabled) {
      border-color: #1a237e;
      background-color: #f8f9fa;
      transform: translateY(-2px);
      box-shadow: 0 4px 6px rgba(0,0,0,0.05);
    }
    .choice-card.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background-color: #f1f3f5;
    }
    .choice-icon-wrapper {
      width: 40px;
      height: 40px;
      background-color: #f0f2f5;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 1rem;
    }
    .choice-icon {
      font-size: 1.25rem;
      width: 1.25rem;
      height: 1.25rem;
      color: #1a237e;
    }
    .choice-text {
      display: flex;
      flex-direction: column;
    }
    .choice-text strong {
      color: #333;
      font-size: 1rem;
    }
    .choice-text span {
      font-size: 0.85rem;
      color: #777;
    }
    .upload-card {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 0.65rem;
      border-style: dashed;
      border-color: #cbd5f5;
      background-color: #f8f9ff;
    }
    .upload-card.drag-over {
      border-color: #1a237e;
      background-color: #eef1ff;
    }
    .upload-cta {
      font-size: 0.85rem;
      color: #3b3f66;
    }
    .upload-file {
      font-size: 0.8rem;
      color: #1a237e;
      font-weight: 600;
      word-break: break-all;
    }
    .upload-error {
      font-size: 0.8rem;
      color: #b42318;
    }
    .modal-footer {
      padding: 1rem 1.5rem 1.5rem;
      display: flex;
      justify-content: center;
      background-color: #fcfcfd;
    }
    .btn {
      padding: 0.6rem 1.5rem;
      border-radius: 6px;
      font-weight: 600;
      cursor: pointer;
      border: none;
      transition: all 0.2s;
      font-size: 0.9rem;
    }
    .btn-secondary {
      background-color: #f4f6f9;
      color: #333;
    }
    .btn-secondary:hover {
      background-color: #e2e6ea;
    }
  `]
})
export class CreateTemplateDialogComponent {
  @Input() canDuplicate: boolean = true;
  @Input() uploading: boolean = false;
  @Output() choice = new EventEmitter<'scratch' | 'duplicate'>();
  @Output() importFile = new EventEmitter<File>();
  @Output() cancelled = new EventEmitter<void>();

  @ViewChild('fileInput') fileInput?: ElementRef<HTMLInputElement>;

  isDragOver = false;
  selectedFileName = '';
  errorMessage = '';

  onChoice(type: 'scratch' | 'duplicate') {
    this.choice.emit(type);
  }

  onCancel() {
    this.cancelled.emit();
  }

  openFilePicker() {
    if (this.uploading) {
      return;
    }
    this.fileInput?.nativeElement.click();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files.length ? input.files[0] : null;
    if (file) {
      this.handleFile(file);
    }
    if (input) {
      input.value = '';
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    if (this.uploading) {
      return;
    }
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
    if (this.uploading) {
      return;
    }
    const file = event.dataTransfer && event.dataTransfer.files.length ? event.dataTransfer.files[0] : null;
    if (file) {
      this.handleFile(file);
    }
  }

  private handleFile(file: File) {
    if (!file.name.toLowerCase().endsWith('.xlsx')) {
      this.errorMessage = 'Seuls les fichiers .xlsx sont acceptés';
      this.selectedFileName = '';
      return;
    }
    this.errorMessage = '';
    this.selectedFileName = file.name;
    this.importFile.emit(file);
  }
}
